<template>
  <div>
    <element-renderer
      v-for="elementId in childElementsReversed"
      v-show="!getElementById(elementId)?.layerHiddenInGraphics"
      :id="elementId"
      :key="elementId"
      :type="getElementValueByProp(elementId, 'type')"
      :toggle="toggle"
      :parent="id"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import elementsMixins from '../../mixins/elements-mixins';

export default {
  name: 'LinkedDataElement',
  inheritAttrs: false,
  components: {
    ElementRenderer: defineAsyncComponent(() => import('../Elements/ElementRenderer')),
  },
  mixins: [elementsMixins],
  computed: {
    childElements() {
      return this.getElementGroupMap[this.id] || [];
    },
    childElementsReversed() {
      return [...this.childElements]
        .reverse();
    },
  },
};
</script>
